// Library imports
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MeshBasicMaterial } from "three";

// Interface imports
import { IConfig, IConfigState } from "../../models/config.model";
import { IScene } from "../../models/scene.model";

// Importing thunks to hand getting data
import { getConfig } from "../thunks/config.thunk";

const configInitialState: IConfigState = {
  id: "",
  config: {} as IConfig,
  configLoading: false,
  configError: false,
  imagesLoading: false,
  localLoading: false,
};

const configSlice = createSlice({
  name: "config",
  initialState: configInitialState,
  reducers: {
    setImageLoading: (
      state: IConfigState,
      { payload }: PayloadAction<boolean>
    ) => {
      state.imagesLoading = payload;
    },
    setTextures: (
      state: IConfigState,
      { payload }: PayloadAction<{ id: string; texture: MeshBasicMaterial[] }>
    ) => {
      // console.log("reciveing: ", payload);
      state.config = {
        ...state.config,
        scenes: state.config.scenes.map((scene: IScene) =>
          scene.id === payload.id
            ? { ...scene, textures: payload.texture }
            : scene
        ),
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getConfig.rejected, (state: IConfigState) => {
      state.configLoading = false;
      state.configError = true;
    });
    builder.addCase(getConfig.pending, (state: IConfigState) => {
      state.configLoading = true;
      state.configError = false;
    });
    builder.addCase(
      getConfig.fulfilled,
      (state: IConfigState, { payload }: PayloadAction<IConfig>) => {
        state.configLoading = false;
        state.config = payload;
        state.id = payload.id;
      }
    );
  },
});

export const { setImageLoading, setTextures } = configSlice.actions;

export default configSlice.reducer;
